import { Picker } from "@react-native-picker/picker";
import React from "react";
import { View } from "react-native";

export type DropdownOption = {
  value: string;
  label: string;
  icon?: string;
};

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: DropdownOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  triggerClassName?: string;
  testID?: string;
  iconOnlyTrigger?: boolean;
  ariaLabel?: string;
};

export default function Dropdown({
  value,
  onChange,
  options,
  disabled,
  className = "",
  testID,
  ariaLabel,
}: Props) {
  return (
    <View
      className={`rounded-xl border bg-white border-gray-200 ${className}`}
      testID={testID}
      accessibilityLabel={ariaLabel}
    >
      <Picker
        enabled={!disabled}
        selectedValue={value}
        onValueChange={(itemValue) => onChange(String(itemValue))}
        dropdownIconColor="#6B7280"
      >
        {options.map((o) => (
          <Picker.Item
            key={o.value}
            label={o.icon ? `${o.icon} ${o.label}` : o.label}
            value={o.value}
          />
        ))}
      </Picker>
    </View>
  );
}
